import { AutocompleteViewStoreInterface } from 'common/module/autocomplete/view-store.interface';
import { AutocompleteViewStoreFactory } from 'desktop/module/autocomplete/view-store.factory';

const service = AutocompleteViewStoreFactory();

export function BuildingReviewLandingAutocompleteService(): AutocompleteViewStoreInterface {
  return service;
}
